import { Trans } from '@lingui/react'

import { isRebrandingITActive } from 'shared/experiments/utils/rebranding'
import IconChat from 'views/components/atoms/Icon/IconChat'
import IconSmartphone from 'views/components/atoms/Icon/IconSmartphone'
import TextWithIcon from 'views/components/molecules/TextWithIcon'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'

const ProductConsultationDirect = () => {
  const {
    publicRuntimeConfig: {
      pageProperties: { experiments },
    },
  } = useShopAndRuntimeConfig()
  const isRebrandingEnabled = isRebrandingITActive(experiments)

  return (
    <>
      <p className="o-ProductConsultationDirect__text">
        <Trans id="product.consultation.direct.headline" />
      </p>
      <TextWithIcon
        icon={
          isRebrandingEnabled ? (
            <IconChat size="large" />
          ) : (
            <IconSmartphone size="large" className="u-color--blue" />
          )
        }
      >
        <h4 className="a-h2 u-no-margin">
          <TransWithHtml
            id="product.consultation.direct.contact"
            className="o-ProductConsultationDirect__subtext"
          />
        </h4>
      </TextWithIcon>
    </>
  )
}

export default ProductConsultationDirect
